import React from 'react';
import * as Styled from './EmptyOrdersCard.styled';

/**
 * Displays ShopButtons when a user does not have previous orders
 */
const EmptyOrdersCard = () => (
  <Styled.EmptyOrdersCard>
    <Styled.EmptyOrdersTitle>
      You don’t have any orders yet.
    </Styled.EmptyOrdersTitle>
    <Styled.ShopButtons />
  </Styled.EmptyOrdersCard>
);

export default EmptyOrdersCard;
